import React, { useEffect, useState } from "react";
import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./dashboard";
import UserList from "./userList";
import ItemsList from "./itemsList";
import VendorList from "./vendorlist";
import Stock from "./stock";
import Expenditure from "./expenditure";
import ExpenditureSubNew from "./expenditure_sub_new";
import Expenditure_V1 from "./expenditure_v1";
import ExpenditureList from "./ExpenditureList";
import Login from "./Login";
import MobileHome from "./Mobilehome";
import Layout from "./Layout";
import Requisition from "./requisition";
import Requisition_v1 from "./requisition_v1";
import RequisitionPO from "./requisitionPO";
import POReport from "./POReport";
import PurchaseList from "./purchaseList";
import InstallPromptModal from "./components/InstallPromptModal";
import KitchenList from "./kitchenList";

import SubKitchen from "./subkitchen"
import OperatorList from "./operatorList";
import AdminStock from "./adminstock";
import AdminExpenditure from "./adminexpenditure";
import ProjectAdminKitchen from "./ProjectAdminKitchen";
import RequisitionAdmin from "./requisition-admin";
import RequisitionDetails from "./requisition-details";
import RequisitionDetailsPO from "./requisition-detailsPO";
import Requisitionadminlist from "./requisition-admin-list";

// import invoice from "./purchaseorder";
// import Invoice from "./purchaseorder";
import AdminInvoice from "./adminInvoice";
import CategoryList from "./CategoryList";
import ExpenditureKitchenDetails from "./ExpenditureKitchenDetails";
import ExpenditureListKitchen from "./expenditureListKitchen";
import ExpenditureListKitchenSub from "./expenditureListSubNewKitchen";
import ExpenditureListKitchen2 from "./expenditureListKitchen2";
import PurchaseOrder from "./purchaseorder";
import PurchaseOrderlist from "./PurchaseOrderlist";
import PurchaseOrderlist2 from "./PurchaseOrderlist2";
import PurchaseOrderListNew from "./PurchaseOrderlistNew";
import ProtectedRoute from "./components/ProtectedRoute";
import KitchenStock from "./KitchenStock";
import POList from "./POList";
import RequisitionList from "./RequisitionList";
import RequisitionListPO from "./RequisitionListPO";
import POListMenu from "./POListMenu";
import Invoice2 from "./Invoice2";
import AdminExpenditure2 from "./adminExpenditure2";
import ExpenditureKitchenDetails2 from "./ExpenditureKitchenDetails2";
// import unauthorized from "./components/Unathorized";
import Sub_kichen_home from "./sub_kichen_home";
import AddKitchen from "./AddKitchen";
import ExpenditureListSubKitchen from "./expenditureListSubKitchen";
import ExpenditureSub from "./expenditureSub";
import PurchaseReportList from "./Purchase-role/PurchaseReportList";
import PurchaseReport from "./Purchase-role/PurchaseReport";
import PurchaseItemsList from "./Purchase-role/PurchaseItemsList";
import CurrentDateList from "./components/CurrentDateList";
import WestDateList from "./components/WestDateList";
import CurrentDateListv1 from "./components/CurrentDateListv1";
import PastDataList from "./components/PastDataList";
import KitchenProjectHome from "./KitchenProjectHome";
import Dashboardv1 from "./components/Dashboardv1";
import DashboardvMain1 from "./components/DashboardvMain1";
import DashboardvMainAdmin from "./components/DashboardvMainAdmin";
import DashboardV3 from "./components/DashboardV3";
import Dashboardv2 from "./components/Dashboardv2";
import Test from "./components/test";
import PurchaseDashboard from "./Purchase-role/PurchaseDashboard"
import ReceiptReport from "./Purchase-role/ReceiptReport"
import StockRegisterReport from "./Purchase-role/StockRegisterReport"
import PurchaseStock from "./Purchase-role/PurchaseStock"
import PurchaseExpenditure from "./Purchase-role/PurchaseExpenditure"
import AddExpenditure from "./Purchase-role/AddExpenditure"
import PurchasePO from "./Purchase-role/PurchasePO"
import AddPurchase from "./Purchase-role/AddPurchase"
import EditPurchase from "./Purchase-role/EditPurchase"
import MealsHome from "./MealsHome"
import MealsReport from "./MealsReport"

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/");
    }
  }, [navigate]);
  // const location = useLocation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("User response to the install prompt:", outcome);
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  return (
    <>
      <div className="overflow-hidden mb-5">
        {/* Show modal if PWA install prompt is available */}
        {showPrompt && (
          <InstallPromptModal
            onInstall={handleInstall}
            onClose={() => setShowPrompt(false)}
          />
        )}

        <Routes>
          <Route path="/" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["user", "admin"]}>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchaseDashboard"
            element={
              <Layout>
                <PurchaseDashboard />
              </Layout>
            }
          />
          <Route
            path="/receiptReport"
            element={
              <Layout>
                <ReceiptReport />
              </Layout>
            }
          />
          <Route
            path="/StockRegisterReport"
            element={
              <Layout>
                <StockRegisterReport />
              </Layout>
            }
          />
          <Route
            path="/purchaseExpenditure"
            element={
              <Layout>
                <PurchaseExpenditure />
              </Layout>
            }
          />
          <Route
            path="/dashboard_main"
            element={
              <Layout>
                <DashboardvMainAdmin />
              </Layout>
            }
          />

          <Route
            path="/dashboard_v3"
            element={
              <Layout>
                <DashboardV3 />
              </Layout>
            }
          />

          <Route
            path="/addExpenditure"
            element={
              <Layout>
                <AddExpenditure />
              </Layout>
            }
          />
          <Route
            path="/purchaseStock"
            element={
              <Layout>
                <PurchaseStock />
              </Layout>
            }
          />

          <Route
            path="/adminExpenditure"
            element={
              <Layout>
                <AdminExpenditure />
              </Layout>
            }
          />
          <Route
            path="/ProjectAdminKitchen"
            element={
              <Layout>
                <ProjectAdminKitchen />
              </Layout>
            }
          />
          <Route
            path="/admininvoice"
            element={
              <Layout>
                <AdminInvoice />
              </Layout>
            }
          />
          <Route
            path="/purchasePO"
            element={
              <Layout>
                <PurchasePO />
              </Layout>
            }
          />
          <Route
            path="/addPurchase"
            element={
              <Layout>
                <AddPurchase />
              </Layout>
            }
          />
          <Route
            path="/editPurchase"
            element={
              <Layout>
                <EditPurchase />
              </Layout>
            }
          />
          <Route
            path="/purchaseorder"
            element={
              <Layout>
                <PurchaseOrder />
              </Layout>
            }
          />
          <Route
            path="/unauthorized"
            element={
              <Layout>
                <h1>You Have Not access</h1>
              </Layout>
            }
          />
          <Route
            path="/userList"
            element={
              <Layout>
                <UserList />
              </Layout>
            }
          />
          <Route
            path="/operatorList"
            element={
              <Layout>
                <OperatorList />
              </Layout>
            }
          />
          <Route
            path="/adminStock"
            element={
              <Layout>
                <AdminStock />
              </Layout>
            }
          />
          <Route
            path="/kitchenList"
            element={
              <Layout>
                <KitchenList />
              </Layout>
            }
          />
          <Route
            path="/subKitchen"
            element={
              <Layout>
                <SubKitchen />
              </Layout>
            }
          />
          <Route
            path="/Sub_kichen_home"
            element={
              <Layout>
                <Sub_kichen_home />
              </Layout>
            }
          />

          <Route
            path="/requisition-admin-list"
            element={
              <Layout>
                <Requisitionadminlist />
              </Layout>
            }
          />
          <Route
            path="/itemsList"
            element={
              <Layout>
                <ItemsList />
              </Layout>
            }
          />
          <Route
            path="/vendorlist"
            element={
              <Layout>
                <VendorList />
              </Layout>
            }
          />
          <Route
            path="/stock"
            element={
              <Layout>
                <Stock />
              </Layout>
            }
          />
          <Route
            path="/expenditure"
            element={
              <Layout>
                <Expenditure />
              </Layout>
            }
          />
          <Route
            path="/expenditureSubNew"
            element={
              <Layout>
                <ExpenditureSubNew />
              </Layout>
            }
          />
          <Route
            path="/expenditure_v1"
            element={
              <Layout>
                <Expenditure_V1 />
              </Layout>
            }
          />
          <Route
            path="/requisition"
            element={
              <Layout>
                <Requisition />
              </Layout>
            }
          />
          <Route
            path="/requisition_v1"
            element={
              <Layout>
                <Requisition_v1 />
              </Layout>
            }
          />

          <Route
            path="/requisitionPO"
            element={
              <Layout>
                <RequisitionPO />
              </Layout>
            }
          />
          <Route
            path="/POReport"
            element={
              <Layout>
                <POReport />
              </Layout>
            }
          />
          <Route
            path="/PurchaseList"
            element={
              <Layout>
                <PurchaseList />
              </Layout>
            }
          />


          <Route
            path="/requisitionadmin"
            element={
              <Layout>
                <RequisitionAdmin />
              </Layout>
            }
          />
          <Route
            path="/categorylist"
            element={
              <Layout>
                <CategoryList />
              </Layout>
            }
          />
          <Route
            path="/requisition-details"
            element={
              <Layout>
                <RequisitionDetails />
              </Layout>
            }
          />

          <Route
            path="/requisition-detailsPO"
            element={
              <Layout>
                <RequisitionDetailsPO />
              </Layout>
            }
          />

          <Route
            path="/ExpenditureKitchenDetails"
            element={
              <Layout>
                <ExpenditureKitchenDetails />
              </Layout>
            }
          />
          <Route
            path="/ExpenditureListKitchen"
            element={
              <Layout>
                <ExpenditureListKitchen />
              </Layout>
            }
          />
          <Route
            path="/ExpenditureListKitchenSub"
            element={
              <Layout>
                <ExpenditureListKitchenSub />
              </Layout>
            }
          />
          <Route
            path="/ExpenditureListKitchen2"
            element={
              <Layout>
                <ExpenditureListKitchen2 />
              </Layout>
            }
          />
          <Route
            path="/purchaseorderlists"
            element={
              <Layout>
                <PurchaseOrderlist />
                {/* <h1>ananannsdjdbhv</h1> */}
              </Layout>
            }
          />
          <Route
            path="/purchaseorderlists2"
            element={
              <Layout>
                <PurchaseOrderlist2 />
              </Layout>
            }
          />
          <Route
            path="/purchaseorderlistnew"
            element={
              <Layout>
                <PurchaseOrderListNew />
              </Layout>
            }
          />
          <Route path="/expenditure-list" element={<ExpenditureList />} />

          <Route
            path="/mobilehome"
            element={
              <Layout>
                <MobileHome />
              </Layout>
            }
          />

          <Route
            path="/kitchenStock"
            element={
              <Layout>
                <KitchenStock />
              </Layout>
            }
          />

          <Route
            path="/POList"
            element={
              <Layout>
                <POList />
              </Layout>
            }
          />

          <Route
            path="/requisitionList"
            element={
              <Layout>
                <RequisitionList />
              </Layout>
            }
          />

          <Route
            path="/requisitionListPO"
            element={
              <Layout>
                <RequisitionListPO />
              </Layout>
            }
          />

          <Route
            path="/POListMenu"
            element={
              <Layout>
                <POListMenu />
              </Layout>
            }
          />

          <Route
            path="/invoice"
            element={
              <Layout>
                <Invoice2 />
              </Layout>
            }
          />

          <Route
            path="/adminexpenditure2"
            element={
              <Layout>
                <AdminExpenditure2 />
              </Layout>
            }
          />

          <Route
            path="/expenditurekitchendetails2"
            element={
              <Layout>
                <ExpenditureKitchenDetails2 />
              </Layout>
            }
          />


          <Route
            path="/addkitchen"
            element={
              <Layout>
                <AddKitchen />
              </Layout>
            }
          />

          <Route
            path="/expenditureSub"
            element={
              <Layout>
                <ExpenditureSub />
              </Layout>
            }
          />
          <Route
            path="/ExpenditureListSubKitchen"
            element={
              <Layout>
                <ExpenditureListSubKitchen />
              </Layout>
            }
          />
          <Route
            path="/PurchaseReportList"
            element={
              <Layout>
                <PurchaseReportList />
              </Layout>
            }
          />
          <Route
            path="/PurchaseReport"
            element={
              <Layout>
                <PurchaseReport />
              </Layout>
            }
          />


          <Route
            path="/PurchaseItemsList"
            element={
              <Layout>
                <PurchaseItemsList />
              </Layout>
            }
          />
          <Route
            path="/CurrentDateList"
            element={
              <Layout>
                <CurrentDateList />
              </Layout>
            }
          />
          <Route
            path="/WestDateList"
            element={
              <Layout>
                <WestDateList />
              </Layout>
            }
          />
          <Route
            path="/CurrentDateListv1"
            element={
              <Layout>
                <CurrentDateListv1 />
              </Layout>
            }
          />
          <Route
            path="/PastDataList"
            element={
              <Layout>
                <PastDataList />
              </Layout>
            }
          />
          <Route
            path="/KitchenProjectHome"
            element={
              <Layout>
                <KitchenProjectHome />
              </Layout>
            }
          />
          <Route
            path="/Dashboardv1"
            element={
              <Layout>
                <Dashboardv1 />
              </Layout>
            }
          />
          <Route
            path="/DashboardvMain1"
            element={
              <Layout>
                <DashboardvMain1 />
              </Layout>
            }
          />
          <Route
            path="/Dashboardv2"
            element={
              <Layout>
                <Dashboardv2 />
              </Layout>
            }
          />
          <Route
            path="/Test"
            element={
              <Layout>
                <Test />
              </Layout>
            }
          />
          <Route
            path="/MealsHome"
            element={
              <Layout>
                <MealsHome />
              </Layout>
            }
          />
          <Route
            path="/MealsReport"
            element={
              <Layout>
                <MealsReport />
              </Layout>
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default App;
